<template>
  <div class="dimmed">
    <div class="step4 preview-layer">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewLayer'
}
</script>

<style lang="scss">
.dimmed {
  .step4.preview-layer {
    width: 740px;
    height: 800px;
    border-radius: 34px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    @include positionXYcenter;

    .step-title {
      text-align: center;
      margin-top: 35px;

      .title__text {
        position: relative;
        display: inline-block;
        font-size: 18px;
        font-weight: 600;
        line-height: 1;
        color: #2f2f2f;
      }
    }
  }
}
</style>
